export default {
  small: '1rem',
} as const;
